import React, { type JSX, type ReactNode } from "react";

export type AdminDetailPanelItem = {
  key: string;
  label: string;
  value: ReactNode;
};

export type AdminDetailPanelSection = {
  items: AdminDetailPanelItem[];
  title: string;
};

export type AdminDetailPanelProps = {
  footer?: ReactNode;
  headerAction?: ReactNode;
  sections: AdminDetailPanelSection[];
  title: string;
};

export function AdminDetailPanel(props: AdminDetailPanelProps): JSX.Element {
  return (
    <aside
      style={{
        padding: "20px",
        borderRadius: "22px",
        background: "rgba(255, 255, 255, 0.82)",
        border: "1px solid rgba(24, 33, 43, 0.08)",
        boxShadow: "0 18px 36px rgba(15, 23, 42, 0.08)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <h3 style={{ margin: 0, fontSize: "1.05rem", letterSpacing: "-0.02em" }}>{props.title}</h3>
        {props.headerAction}
      </div>

      <div style={{ display: "grid", gap: "18px", marginTop: "18px" }}>
        {props.sections.map((section) => (
          <section key={section.title}>
            <p
              style={{
                margin: 0,
                color: "#9a3412",
                fontSize: "0.78rem",
                fontWeight: 700,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}
            >
              {section.title}
            </p>
            <dl
              style={{
                margin: "10px 0 0",
                display: "grid",
                gridTemplateColumns: "minmax(96px, 140px) minmax(0, 1fr)",
                gap: "8px 12px",
              }}
            >
              {section.items.map((item) => (
                <div
                  key={item.key}
                  style={{
                    display: "contents",
                  }}
                >
                  <dt style={{ color: "#64748b", fontSize: "0.88rem" }}>{item.label}</dt>
                  <dd style={{ margin: 0, color: "#18212b", fontSize: "0.9rem", fontWeight: 600 }}>
                    {item.value}
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>

      {props.footer ? <div style={{ marginTop: "18px" }}>{props.footer}</div> : null}
    </aside>
  );
}
